import { render } from "./productLayout.vue?vue&type=template&id=212b3374&scoped=true&ts=true"
import script from "./productLayout.vue?vue&type=script&lang=ts"
export * from "./productLayout.vue?vue&type=script&lang=ts"

import "./productLayout.vue?vue&type=style&index=0&id=212b3374&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212b3374"]])

export default __exports__